
import React from 'react';
import { CalendarIcon, Clock, User } from 'lucide-react';

interface PostMetadataProps {
  author: string;
  publishedDate: string | null;
  readTime: string;
}

const PostMetadata: React.FC<PostMetadataProps> = ({ author, publishedDate, readTime }) => {
  return (
    <div className="flex items-center space-x-6 mb-6 text-sm text-muted-foreground">
      <div className="flex items-center gap-2">
        <User className="h-4 w-4" />
        <span>{author}</span>
      </div>
      <div className="flex items-center gap-2">
        <CalendarIcon className="h-4 w-4" />
        <span>
          {publishedDate 
            ? new Date(publishedDate).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })
            : 'Not published'
          }
        </span>
      </div>
      <div className="flex items-center gap-2">
        <Clock className="h-4 w-4" />
        <span>{readTime}</span>
      </div>
    </div>
  );
};

export default PostMetadata;
